module.exports = __webpack_public_path__ + "static/media/COS_ZYDUS.b5d12c23.jpg";